import { Component } from '@angular/core';
import { BusinessRole, PartyService } from '@app/api/dmc';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { FormApiService } from '@app/core/services/form-api.service';
import { sortByTranslation } from '@app/core/utils/sort-by-translation';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-create-actor-modal',
  imports: [
    ReactiveFormsModule,
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    TranslatePipe,
    SelectDirective
  ],
  templateUrl: './create-actor-modal.component.html',
  styleUrl: './create-actor-modal.component.css'
})
export class CreateActorModalComponent implements HasUnsavedChanges {
  /** Form **/
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    businessRole: new FormControl(null, Validators.required),
    name: new FormControl(null, Validators.required),
    identification: new FormControl<string | null>(null, Validators.required),
  });

  /** Business role **/
  public businessRoleList: KeyValue[] = sortByTranslation(enumToKeyValue(BusinessRole, { omitKeys: ['NotSpecified'], prefixValue: 'actor.businessrole.' }));

  constructor(
    private readonly partyService: PartyService,
    private readonly formApiService: FormApiService,
  ) {
  }

  public submit(): void {
    this.formApiService.submit(
      this.form,
      (data) => this.partyService.partyNewActorRegisterPost(data),
      {
        closeModal: true,
        successMessage: 'actorregister.create.success'
      }
    )
  }
}
